import { AnyAction } from "redux";
import * as types from "./types";

import { initialState } from "./index";

export default function requirementDetailsReducer(
  state = initialState,
  action: AnyAction,
) {
  switch (action.type) {
    case types.GET_REQUIREMENT_SUCCESS: {
      return {
        ...state,
        requirement: { ...action.payload.requirement },
        isRequirementLoading: action.payload.isRequirementLoading,
      };
    }
    case types.GET_REQUIREMENT: {
      return {
        ...state,
        isRequirementLoading: action.payload.isRequirementLoading,
      };
    }
    case types.GET_REQUIREMENT_ERROR: {
      return {
        ...state,
        isRequirementLoading: action.payload.isRequirementLoading,
        hasErrorLoadingRequirement: action.payload.hasErrorLoadingRequirement,
      };
    }
    default:
      return state;
  }
}
